module.exports = __webpack_public_path__ + "static/media/fe_2.45c2a0eb.png";